export default __webpack_public_path__ + "media/images/services-05-350x220-123f6d275831417da7faf93a81063193.jpg";